import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./InsightsBackButton.css";

export default function InsightsBackButton({
  to = "/insights",
  label = "Hobbli Insights",
  className = "",
}) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={`insights-back-button ${className}`.trim()}
      onClick={() => navigate(to)}
    >
      <FaArrowLeft aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}
